import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';

let ffmpeg = null;
let loaded = false;

export const loadFFmpeg = async (onProgress) => {
  if (loaded) return ffmpeg;
  
  ffmpeg = new FFmpeg();
  
  ffmpeg.on('progress', ({ progress }) => {
    if (onProgress) onProgress(Math.round(progress * 100));
  });

  const baseURL = 'https://unpkg.com/@ffmpeg/core@0.12.6/dist/esm';
  
  await ffmpeg.load({
    coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
    wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
  });
  
  loaded = true;
  return ffmpeg;
};

export const compressVideo = async (file, onProgress) => {
  const ffmpeg = await loadFFmpeg(onProgress);
  
  const inputName = 'input' + getExtension(file.name);
  const outputName = 'output.mp4';
  
  // Write input file
  await ffmpeg.writeFile(inputName, await fetchFile(file));
  
  // Compress: reduce bitrate, scale down if very large, maintain decent quality
  // -crf 28 is good balance of quality/size for analysis
  // -preset fast for reasonable compression time
  // Scale to max 1280 width while maintaining aspect ratio
  await ffmpeg.exec([
    '-i', inputName,
    '-vf', 'scale=min(1280\\,iw):-2',
    '-c:v', 'libx264',
    '-crf', '28',
    '-preset', 'fast',
    '-c:a', 'aac',
    '-b:a', '128k',
    '-movflags', '+faststart',
    outputName
  ]);
  
  // Read output
  const data = await ffmpeg.readFile(outputName);
  
  // Cleanup
  await ffmpeg.deleteFile(inputName);
  await ffmpeg.deleteFile(outputName);
  
  // Create blob
  const blob = new Blob([data.buffer], { type: 'video/mp4' });
  return new File([blob], file.name.replace(/\.[^.]+$/, '.mp4'), { type: 'video/mp4' });
};

const getExtension = (filename) => {
  const ext = filename.split('.').pop().toLowerCase();
  return '.' + ext;
};

export const getFileSizeMB = (file) => {
  return (file.size / (1024 * 1024)).toFixed(1);
};

export const shouldCompress = (file) => {
  // Suggest compression for files over 50MB
  return file.size > 50 * 1024 * 1024;
};
